import CopyFieldToClipboard from '../components/CopyFieldToClipboard'

export default class PublicationJobsArticleJobsAssetPreviews {
  constructor(params) {}

  show() {
    new CopyFieldToClipboard();

    N2.bindHandler('swipeleft', $('.js-swipe-image').hammer(), (evt) => {
      $('.js-right').click();
    });
    N2.bindHandler('swiperight', $('.js-swipe-image').hammer(), (evt) => {
      $('.js-left').click();
    });
  }
}
